module.exports = "/static/img/placeholder3.png?8813d7216339267548df9010f75b596b";